module.exports = __webpack_public_path__ + "img/kaola.4654a7a0.png";